// Content for the /services/:slug pages, the home page services grid,
// the header dropdown and the footer.
const services = [
  {
    slug: 'web-development',
    name: 'Web Development',
    icon: 'code',
    short: 'Fast, accessible web apps and platforms built on modern frameworks.',
    serviceType: 'Web Development',
    schemaName: 'Web Development Services',
    schemaDescription:
      'Professional web development services including responsive websites, web applications, and e-commerce solutions.',
    seo: {
      title: 'Web Development Services',
      description:
        'Professional web development services. We build responsive, modern web applications using the latest frameworks and technologies. From simple websites to complex web platforms.',
      keywords:
        'web development, web applications, responsive websites, React development, frontend development, full-stack development',
    },
    heroTitle: 'Web apps that feel instant.',
    heroSubtitle: 'Building modern, responsive web applications that drive business growth.',
    introTitle: 'Comprehensive web development solutions',
    intro:
      'We build responsive, modern web applications using the latest frameworks and technologies. From simple websites to complex web platforms, we deliver solutions that are both beautiful and functional. Our team specializes in creating user-centric designs that provide exceptional user experiences while meeting your business objectives.',
    featuresTitle: 'What we offer',
    features: [
      { icon: 'globe', title: 'Responsive Web Design', description: 'Websites that look and work perfectly on all devices: desktops, tablets, and mobile phones.' },
      { icon: 'layers', title: 'Modern Frameworks', description: 'Expertise in React, Vue.js, Next.js, and other cutting-edge frameworks for scalable applications.' },
      { icon: 'cart', title: 'E-Commerce Solutions', description: 'Robust online stores with secure payment processing and inventory management.' },
      { icon: 'lock', title: 'Secure Applications', description: "Security best practices that protect your data and your users' information." },
      { icon: 'gauge', title: 'Performance Optimization', description: 'Optimized loading times for fast, efficient web applications that keep users engaged.' },
      { icon: 'wrench', title: 'Maintenance & Support', description: 'Ongoing support and updates to keep your web application running smoothly and securely.' },
    ],
    stackTitle: 'Technologies we use',
    stack: [
      { title: 'Frontend', items: ['React & Next.js', 'Vue.js & Nuxt.js', 'TypeScript', 'Tailwind CSS & Bootstrap'] },
      { title: 'Backend', items: ['Node.js & Express', 'Python & Django', 'PHP & Laravel', 'RESTful & GraphQL APIs'] },
      { title: 'Database', items: ['PostgreSQL', 'MongoDB', 'MySQL', 'Redis'] },
    ],
    cta: {
      title: 'Ready to build your web application?',
      description: "Let's discuss your project and create a custom solution that meets your business needs.",
    },
  },
  {
    slug: 'mobile-applications',
    name: 'Mobile Applications',
    icon: 'mobile',
    short: 'Native and cross-platform apps for iOS and Android that users keep.',
    serviceType: 'Mobile Application Development',
    schemaName: 'Mobile Application Development Services',
    schemaDescription: 'Professional mobile app development for iOS, Android, and cross-platform solutions.',
    seo: {
      title: 'Mobile Application Development Services',
      description:
        'Our mobile development expertise spans iOS, Android, and cross-platform solutions. We create intuitive, performant mobile apps that engage users and deliver exceptional experiences.',
      keywords:
        'mobile app development, iOS development, Android development, React Native, Flutter, cross-platform apps',
    },
    heroTitle: 'Mobile apps people actually open.',
    heroSubtitle: 'Creating intuitive, high-performance mobile apps for iOS, Android, and cross-platform.',
    introTitle: 'Comprehensive mobile development solutions',
    intro:
      'Our mobile development expertise spans iOS, Android, and cross-platform solutions. We create intuitive, performant mobile apps that engage users and deliver exceptional experiences. From concept to deployment, we guide you through every step of the mobile app development process.',
    featuresTitle: 'What we offer',
    features: [
      { icon: 'apple', title: 'iOS Development', description: 'Native iOS apps built with Swift and SwiftUI, optimized for iPhone and iPad devices.' },
      { icon: 'android', title: 'Android Development', description: 'Native Android applications using Kotlin and Jetpack Compose for modern, responsive UIs.' },
      { icon: 'refresh', title: 'Cross-Platform Solutions', description: 'React Native and Flutter apps that work seamlessly across iOS and Android platforms.' },
      { icon: 'palette', title: 'UI/UX Design', description: 'User-centered design that creates intuitive, engaging mobile experiences.' },
      { icon: 'shield', title: 'App Security', description: 'Robust security measures to protect user data and ensure app integrity.' },
      { icon: 'rocket', title: 'App Store Deployment', description: 'Complete support for publishing your app to the Apple App Store and Google Play Store.' },
    ],
    stackTitle: 'Technologies we use',
    stack: [
      { title: 'Native iOS', items: ['Swift & SwiftUI', 'Objective-C', 'Xcode', 'Core Data'] },
      { title: 'Native Android', items: ['Kotlin & Java', 'Jetpack Compose', 'Android Studio', 'Room Database'] },
      { title: 'Cross-Platform', items: ['React Native', 'Flutter', 'Ionic', 'Xamarin'] },
    ],
    cta: {
      title: 'Ready to build your mobile app?',
      description: "Let's discuss your mobile app idea and bring it to life with cutting-edge technology.",
    },
  },
  {
    slug: 'cloud-solutions',
    name: 'Cloud Solutions',
    icon: 'cloud',
    short: 'Scalable, secure infrastructure, CI/CD and cost-aware cloud architecture.',
    serviceType: 'Cloud Computing Solutions',
    schemaName: 'Cloud Solutions Services',
    schemaDescription: 'Scalable, secure, and cost-effective cloud computing solutions for businesses.',
    seo: {
      title: 'Cloud Solutions Services',
      description:
        'We help businesses leverage the power of cloud computing with scalable, secure, and cost-effective solutions. Our cloud services enable organizations to innovate faster and scale efficiently.',
      keywords: 'cloud computing, AWS, Azure, Google Cloud, cloud migration, cloud architecture, DevOps',
    },
    heroTitle: 'Infrastructure that scales itself.',
    heroSubtitle: 'Scalable, secure cloud infrastructure that grows with your business.',
    introTitle: 'Comprehensive cloud services',
    intro:
      'We help businesses leverage the power of cloud computing with scalable, secure, and cost-effective solutions. Our cloud services enable organizations to innovate faster and scale efficiently. From migration to optimization, we provide end-to-end cloud solutions tailored to your needs.',
    featuresTitle: 'What we offer',
    features: [
      { icon: 'cloud', title: 'Cloud Migration', description: 'Seamless migration of your applications and data to the cloud with minimal downtime.' },
      { icon: 'server', title: 'Cloud Architecture', description: 'Scalable, resilient cloud architectures optimized for performance.' },
      { icon: 'shield', title: 'Cloud Security', description: 'Comprehensive security measures to protect your cloud infrastructure and data.' },
      { icon: 'pipeline', title: 'DevOps & CI/CD', description: 'Automated deployments and streamlined development workflows with modern DevOps practices.' },
      { icon: 'coins', title: 'Cost Optimization', description: 'Lower cloud costs while maintaining performance and scalability.' },
      { icon: 'activity', title: 'Cloud Monitoring', description: 'Continuous monitoring and management to ensure optimal cloud performance.' },
    ],
    stackTitle: 'Cloud platforms we work with',
    stack: [
      { title: 'Amazon Web Services', items: ['EC2 & Lambda', 'S3 & RDS', 'CloudFormation', 'EKS & ECS'] },
      { title: 'Microsoft Azure', items: ['Azure App Service', 'Azure Functions', 'Azure SQL Database', 'Azure Kubernetes'] },
      { title: 'Google Cloud', items: ['Compute Engine', 'Cloud Functions', 'Cloud SQL', 'GKE'] },
    ],
    cta: {
      title: 'Ready to move to the cloud?',
      description: "Let's discuss how cloud solutions can transform your business operations.",
    },
  },
  {
    slug: 'consulting',
    name: 'Consulting',
    icon: 'compass',
    short: 'Architecture reviews, technology strategy and hands-on engineering guidance.',
    serviceType: 'Technology Consulting',
    schemaName: 'Technology Consulting Services',
    schemaDescription:
      'Strategic technology consulting to help businesses make informed decisions and plan digital transformation.',
    seo: {
      title: 'Technology Consulting Services',
      description:
        'Beyond development, we provide strategic consulting to help businesses make informed technology decisions and plan their digital transformation journeys.',
      keywords:
        'technology consulting, IT consulting, digital transformation, software architecture, technology strategy',
    },
    heroTitle: 'Clear technical decisions, faster.',
    heroSubtitle: 'Strategic guidance for your digital transformation journey.',
    introTitle: 'Expert technology consulting',
    intro:
      'Beyond development, we provide strategic consulting to help businesses make informed technology decisions and plan their digital transformation journeys. Our experienced consultants work closely with you to understand your business goals and recommend the best technology solutions to achieve them.',
    featuresTitle: 'Our consulting services',
    features: [
      { icon: 'map', title: 'Technology Strategy', description: 'Technology roadmaps aligned with your business objectives.' },
      { icon: 'building', title: 'Architecture Design', description: 'Scalable, maintainable software architectures that support long-term growth.' },
      { icon: 'refresh', title: 'Digital Transformation', description: 'Guidance through digital transformation initiatives and modernization.' },
      { icon: 'search', title: 'Technology Assessment', description: 'An evaluation of your current stack that identifies where to improve.' },
      { icon: 'book', title: 'Team Training', description: 'Training and knowledge transfer that empower your development teams.' },
      { icon: 'target', title: 'Project Planning', description: 'Detailed project plans and timelines for successful technology implementations.' },
    ],
    stackTitle: 'Consulting areas',
    stack: [
      { title: 'Software Architecture', items: ['System Design', 'Microservices', 'API Design', 'Scalability Planning'] },
      { title: 'Technology Selection', items: ['Framework Evaluation', 'Platform Comparison', 'Tool Recommendations', 'Vendor Assessment'] },
      { title: 'Process Improvement', items: ['Agile Transformation', 'DevOps Implementation', 'CI/CD Setup', 'Quality Assurance'] },
    ],
    cta: {
      title: 'Need expert technology guidance?',
      description: "Let's discuss how our consulting services can help your business succeed.",
    },
  },
];

export const getService = (slug) => services.find((service) => service.slug === slug);

export default services;
